import { create } from 'zustand';

interface LinkPreviewState {
  isOpen: boolean;
  diagramId: string | null;
  open: (diagramId: string) => void;
  close: () => void;
}

export const useLinkPreviewStore = create<LinkPreviewState>((set) => ({
  isOpen: false,
  diagramId: null,
  open: (diagramId) => set({ isOpen: true, diagramId }),
  close: () => set({ isOpen: false, diagramId: null }),
}));

